"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateYearsOptions = exports.StudyYearSelection = void 0;
var _react = require("react");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _studyYear = require("../../utilities/studyYear");
var _dates = require("../../utilities/dates");
var _Menu = require("../../UI/Menu");
var _Icon = require("../../UI/Icon");
var _Radio = require("../../UI/Radio");
var _List = require("../../Data/List");
var _StudyYearSelection = require("./StudyYearSelection.labels");
var _StudyYearSelection2 = _interopRequireDefault(require("./StudyYearSelection.styles"));
var _RangeDatePicker = require("../../UI/DateTimePickers/RangeDatePicker");
var _RadioGroup = require("../../UI/Radio/RadioGroup");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const generateYearsOptions = (numOfYears, numOfSemesters) => {
  const currentStudyYear = (0, _studyYear.getStudyYearDataByDate)(new Date(), numOfSemesters);
  const yearsOptions = [currentStudyYear];
  for (let i = 1; i < Math.max(numOfYears, 1); i++) {
    yearsOptions.push((0, _studyYear.getStudyYearData)(currentStudyYear.startYear - i, numOfSemesters));
  }
  return yearsOptions;
};
exports.generateYearsOptions = generateYearsOptions;
const StudyYearSelection = props => {
  const {
    numOfYears = 3,
    numOfSemesters = 2,
    semesterLabel,
    buttonLabel,
    btnProps,
    enableCustomDates = false,
    userSelection,
    onChange
  } = props;
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    language
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const getLabel = (0, _hooks.useLabels)({
    labels: _StudyYearSelection.labels
  });
  const styles = (0, _StudyYearSelection2.default)(isMobileView);
  const studyYearsOptions = (0, _react.useMemo)(() => generateYearsOptions(numOfYears, numOfSemesters), [numOfYears, numOfSemesters]);
  const defaultUserSelection = (0, _react.useMemo)(() => {
    return {
      isCustomRangeDates: false,
      year: studyYearsOptions[0]
    };
  }, [studyYearsOptions]);
  const [currentUserSelection, setCurrentUserSelection] = (0, _react.useState)();
  const [currentCustomRangeDates, setCurrentCustomRangeDates] = (0, _react.useState)();
  const getSemesterName = (0, _react.useCallback)(semesterKey => {
    const semesterText = semesterLabel?.length ? semesterLabel : getLabel('semester');
    return `${semesterText} ${getLabel(semesterKey.toUpperCase())}`;
  }, [semesterLabel, getLabel]);
  const buildAnchorText = (0, _react.useCallback)(() => {
    let anchorText = '';
    const validUserSelection = userSelection ?? defaultUserSelection;
    if (validUserSelection?.isCustomRangeDates && validUserSelection?.customRangeDates) {
      const dateFormat = '{day}/{month}/{year}';
      const customRangeDates = validUserSelection.customRangeDates;
      anchorText = `${(0, _dates.formatDate)(customRangeDates.startDate, dateFormat)} - ${(0, _dates.formatDate)(customRangeDates.endDate, dateFormat)}`;
    } else {
      const studyYear = validUserSelection?.year;
      anchorText = (language === 'he' ? studyYear?.jewishTitle : studyYear?.title) + ' ';
      if (validUserSelection?.semester) {
        anchorText += getSemesterName(validUserSelection.semester);
      }
    }
    return anchorText;
  }, [language, userSelection, defaultUserSelection, getSemesterName]);
  const handleUserSelection = userSelectionData => {
    setCurrentUserSelection({
      ...userSelectionData,
      customRangeDates: userSelection?.customRangeDates
    });
  };
  const handleCustomDatesChange = (startDate, endDate) => {
    setCurrentCustomRangeDates([startDate, endDate]);
    if (startDate) {
      setCurrentUserSelection({
        isCustomRangeDates: true,
        customRangeDates: {
          startDate,
          endDate: endDate ?? startDate
        }
      });
    }
  };
  const handleCancel = () => {
    setCurrentUserSelection(userSelection ?? defaultUserSelection);
  };
  const handleConfirm = () => {
    if (onChange) {
      let startDate = new Date();
      let endDate = new Date();
      if (currentUserSelection?.isCustomRangeDates && currentUserSelection?.customRangeDates) {
        startDate = currentUserSelection.customRangeDates.startDate;
        endDate = currentUserSelection.customRangeDates.endDate;
      } else if (currentUserSelection?.year) {
        startDate = currentUserSelection?.year?.start;
        endDate = currentUserSelection?.year?.end;
        if (currentUserSelection?.semester) {
          startDate = currentUserSelection?.year?.semesters[currentUserSelection.semester].start;
          endDate = currentUserSelection?.year?.semesters[currentUserSelection.semester].end;
        }
      }
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      onChange(currentUserSelection, startDate, endDate);
    }
  };
  (0, _react.useEffect)(() => {
    if (studyYearsOptions && studyYearsOptions.length > 0) {
      if (userSelection && (userSelection.customRangeDates || studyYearsOptions.find(year => year.startYear === userSelection.year?.startYear))) {
        setCurrentUserSelection(userSelection);
        if (userSelection.customRangeDates) {
          setCurrentCustomRangeDates([userSelection.customRangeDates?.startDate, userSelection?.customRangeDates.endDate]);
        }
      } else {
        setCurrentUserSelection({
          year: studyYearsOptions[0]
        });
      }
    }
  }, [studyYearsOptions, userSelection]);
  if (!studyYearsOptions || studyYearsOptions.length === 0) {
    return null;
  }
  const menuBtnProps = {
    view: 'outlined',
    color: 'basic',
    shape: isMobileView ? 'roundedRectangle' : 'ellipse',
    ...btnProps,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: buttonLabel ? buttonLabel : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-StudyYearSelection__anchor-btn'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: buildAnchorText()
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          name: "Caret",
          width: btnProps?.size === 'large' ? 22 : btnProps?.size === 'small' ? 14 : 18,
          height: btnProps?.size === 'large' ? 22 : btnProps?.size === 'small' ? 14 : 18,
          fillColor: themeColors?.primary.main
        })]
      })
    })
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu.Menu, {
    btnProps: menuBtnProps,
    defaultTitle: getLabel('schoolYear'),
    isBoxCenteredToAnchor: true,
    isWithActionButtons: true,
    onConfirm: handleConfirm,
    onCancel: handleCancel,
    isFullScreen: isMobileView,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-StudyYearSelection'],
      children: [!isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-StudyYearSelection__title'],
        children: getLabel('schoolYear')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-StudyYearSelection__year-options'],
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_RadioGroup.RadioGroup, {
          display: "inline",
          children: [studyYearsOptions?.map(year => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Radio.Radio, {
            id: year.startYear.toString(),
            label: language === 'he' ? year.jewishTitle : year.title,
            isChecked: currentUserSelection?.year?.startYear === year.startYear,
            onClick: () => {
              handleUserSelection({
                isCustomRangeDates: false,
                year
              });
            }
          }, year.startYear.toString())), enableCustomDates && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Radio.Radio, {
            id: 'range',
            label: getLabel('anotherDate'),
            isChecked: currentUserSelection?.isCustomRangeDates,
            onClick: () => {
              handleUserSelection({
                isCustomRangeDates: true
              });
            }
          }, 'range')]
        })
      }), currentUserSelection?.year && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-StudyYearSelection__semester-options'],
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List, {
          children: Object.entries(currentUserSelection?.year.semesters).map(_ref => {
            let [semesterKey, semesterDates] = _ref;
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List.Item, {
              id: `cc-StudyYearSelection__semester-option--${semesterKey}`,
              size: "small",
              isSelected: currentUserSelection && currentUserSelection.semester?.toLowerCase() === semesterKey.toLowerCase(),
              onClick: () => {
                handleUserSelection({
                  isCustomRangeDates: false,
                  year: currentUserSelection?.year,
                  semester: semesterKey
                });
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                children: getSemesterName(semesterKey)
              })
            }, `cc-StudyYearSelection__semester-option--${semesterKey}`);
          })
        })
      }), currentUserSelection?.isCustomRangeDates && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-StudyYearSelection__custom-range-dates'],
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RangeDatePicker.RangeDatePicker, {
          minDate: studyYearsOptions?.[studyYearsOptions.length - 1]?.start,
          maxDate: studyYearsOptions?.[0].end,
          startDate: currentCustomRangeDates?.[0] ?? undefined,
          endDate: currentCustomRangeDates?.[1] ?? undefined,
          onChange: handleCustomDatesChange
        })
      })]
    })
  });
};
exports.StudyYearSelection = StudyYearSelection;